<form #removeForm="ngForm" (ngSubmit)="removeParticipant()" novalidate>
  <h2 mat-dialog-title>Archiving Participant</h2>
  <mat-dialog-content>
    <div class="participant-info">
      <div class="row">
        <span class="label">{{ currentParticipant.type || 'Participant' }}:</span>
        <span class="value">{{ currentParticipant.enisNumber }}</span>
        <span class="flex">{{ currentParticipant.firstName || "" }}</span>
      </div>
    </div>

    <ng-container>
      <mat-form-field>
        <mat-select placeholder="Reason for archiving" [(ngModel)]="selectedReason" required name="selectedReason">
          <mat-option *ngFor="let reason of reasons" [value]="reason">
            {{ reason }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field *ngIf="otherReasonSelected()">
        <input matInput name="otherReason" type="text" required placeholder="Reason for archiving the participant" [(ngModel)]="otherReason" #reasonCtrl="ngModel" />
        <mat-error *ngIf="reasonCtrl.hasError('required')"> Please enter a reason for archiving the participant. </mat-error>
      </mat-form-field>
    </ng-container>
    <ng-template #willRemove>
      <i>Are you sure you want to archive this participant?</i>
    </ng-template>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="spacer"></div>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button type="submit" [disabled]="!isFormValid()">Archive</button>
  </mat-dialog-actions>
</form>
